import { OrganizationKeyName } from "../../../model/Organization";

export const GET_USER_TERM_LIST = "GET_USER_TERM_LIST";
export type GetUserTermListAction = {
  type: typeof GET_USER_TERM_LIST;
  organization: OrganizationKeyName;
};
export const getUserTermListAction = (
  organization: OrganizationKeyName
): GetUserTermListAction => ({
  type: GET_USER_TERM_LIST,
  organization,
});

export const GET_USER_TERM_LIST_FAIL = "GET_USER_TERM_LIST_FAIL";
export type GetUserTermListFailAction = {
  type: typeof GET_USER_TERM_LIST_FAIL;
  organization: OrganizationKeyName;
};
export const getUserTermListFailAction = (
  organization: OrganizationKeyName
): GetUserTermListFailAction => ({
  type: GET_USER_TERM_LIST_FAIL,
  organization,
});

export const GET_USER_TERM_LIST_SUCCESS = "GET_USER_TERM_LIST_SUCCESS";
export type GetUserTermListSuccessAction = {
  type: typeof GET_USER_TERM_LIST_SUCCESS;
  organization: OrganizationKeyName;
  data: any;
};
export const getUserTermListSuccessAction = (
  organization: OrganizationKeyName,
  data: any
): GetUserTermListSuccessAction => ({
  type: GET_USER_TERM_LIST_SUCCESS,
  organization,
  data,
});
